export default {
  apiKey: "AIzaSyB1Q76HMw8ruzAgXCL0Dsqf99VhTOc8FtY",
  authDomain: "vue-trello-f786b.firebaseapp.com",
  projectId: "vue-trello-f786b",
  storageBucket: "vue-trello-f786b.appspot.com",
  messagingSenderId: "813802944914",
  appId: "1:813802944914:web:ffd1254a05a9f4912b694b",
  databaseURL: 'https://vue-trello-f786b-default-rtdb.firebaseio.com'
}